define.alias("checkout/components/seamless-checkout/review-changes-modal", "calendar/components/seamless-checkout/review-changes-modal");